<template>
  <div class="login-container"></div>
</template>

<script>
import {
  getToken,
  setFirebase,
  getReturnUrl,
  removeUrlKey,
} from "@/utils/auth";
import { setNotificationId } from "@/api/notification";
import { getMessaging, getToken as getFirebaseToken } from "firebase/messaging";

export default {
  data() {
    return {
      loading: false,
      connectionFaild: false,
    };
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
  created() {
    this.checkToken();

    // window.addEventListener('hashchange', this.afterQRScan)
  },
  methods: {
    checkToken() {
      if (this.$route.query.token != null) {
        this.$store.commit("SET_TOKEN", this.$route.query.token);
        this.requestPermission();
        const url = getReturnUrl();
        removeUrlKey();
        // this.$store.dispatch("GetUserInfo");
        this.$router.push({ path: url });
        // console.log("recive token from server and go to dashboard");
      } else {
        var tok = getToken();
        // console.log("getToken()=> token=" + tok);
        if (!tok) {
          // console.log("token Not Exist go to OpenID");
          this.handleOpenID("");
        } else {
          //  console.log("token exists go to dashboard");
          this.$router.push({ path: "/" });
        }
      }
    },

    handleOpenID() {
      var url = process.env.VUE_APP_API_ENDPOINT;
      window.location.href = url;
    },

    requestPermission() {
      try {
        Notification.requestPermission().then((data) => {
          if (data == "granted") {
            const messaging = getMessaging();

            return getFirebaseToken(messaging, {
              vapidKey:
                "BG7mRpUd-6n_pXZU7y5ZnJ-7OFtQi8JwJBrgvNuV3R5OmX5Szy9W5URezopIb5YtyU3ckGZuw4mzLO1q_iRx_Wc",
            })
              .then((token) => {

                //console.log(token);
                setNotificationId(token).then((response) => {
                  const data = response.data;
                  setFirebase(token);
                });
              })
              .catch((e) => {
                console.log(e);
              });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style></style>
